module.exports = __webpack_public_path__ + "img/xt_logo.274a37dd.png";